// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/integration/datasource/v1/catalog.proto" (package "c1.api.integration.datasource.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { Empty } from "../../../../../google/protobuf/empty";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { FieldMask } from "../../../../../google/protobuf/field_mask";
import { ConfigSchema } from "../../connector/v1/catalog";
import { Any } from "../../../../../google/protobuf/any";
import { Timestamp } from "../../../../../google/protobuf/timestamp";
/**
 * @generated from protobuf message c1.api.integration.datasource.v1.DataSourceInstallationView
 */
export interface DataSourceInstallationView {
    /**
     * @generated from protobuf field: c1.api.integration.datasource.v1.DataSourceInstallation installation = 1
     */
    installation?: DataSourceInstallation;
    /**
     * @generated from protobuf field: string users_path = 2
     */
    usersPath: string;
}
/**
 * @generated from protobuf message c1.api.integration.datasource.v1.DataSourceInstallation
 */
export interface DataSourceInstallation {
    /**
     * @generated from protobuf field: c1.api.integration.datasource.v1.DataSourceCatalog catalog = 1
     */
    catalog?: DataSourceCatalog;
    /**
     * @generated from protobuf field: string id = 2
     */
    id: string;
    /**
     * @generated from protobuf field: string display_name = 3
     */
    displayName: string;
    /**
     * @generated from protobuf field: string description = 4
     */
    description: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 5
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 6
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 7
     */
    deletedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Any config = 8
     */
    config?: Any;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp first_validated_at = 9
     */
    firstValidatedAt?: Timestamp;
    /**
     * @generated from protobuf field: repeated string admin_user_ids = 10
     */
    adminUserIds: string[];
}
/**
 * @generated from protobuf message c1.api.integration.datasource.v1.DataSourceInstallationRef
 */
export interface DataSourceInstallationRef {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.integration.datasource.v1.DataSourceCatalog
 */
export interface DataSourceCatalog {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: string display_name = 2
     */
    displayName: string;
    /**
     * @generated from protobuf field: string description = 3
     */
    description: string;
    /**
     * @deprecated
     * @generated from protobuf field: string icon_url = 4 [deprecated = true]
     */
    iconUrl: string;
    /**
     * @deprecated
     * @generated from protobuf field: string logo_url = 5 [deprecated = true]
     */
    logoUrl: string;
    /**
     * @generated from protobuf field: bool installed = 6
     */
    installed: boolean;
    /**
     * @generated from protobuf field: string help_url = 7
     */
    helpUrl: string;
}
/**
 * @generated from protobuf message c1.api.integration.datasource.v1.DataSourceCatalogServiceSearchRequest
 */
export interface DataSourceCatalogServiceSearchRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.integration.datasource.v1.DataSourceCatalogServiceSearchResponse
 */
export interface DataSourceCatalogServiceSearchResponse {
    /**
     * @generated from protobuf field: repeated c1.api.integration.datasource.v1.DataSourceCatalog list = 1
     */
    list: DataSourceCatalog[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.integration.datasource.v1.DataSourceExpandMask
 */
export interface DataSourceExpandMask {
    /**
     * @generated from protobuf field: repeated string paths = 1
     */
    paths: string[];
}
/**
 * @generated from protobuf message c1.api.integration.datasource.v1.DataSourceCatalogServiceGetRequest
 */
export interface DataSourceCatalogServiceGetRequest {
    /**
     * @generated from protobuf field: string catalog_id = 1
     */
    catalogId: string;
}
/**
 * @generated from protobuf message c1.api.integration.datasource.v1.DataSourceCatalogServiceSearchInstallationsRequest
 */
export interface DataSourceCatalogServiceSearchInstallationsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string query = 3
     */
    query: string;
    /**
     * @generated from protobuf field: repeated string catalog_ids = 4
     */
    catalogIds: string[];
    /**
     * @generated from protobuf field: repeated c1.api.integration.datasource.v1.DataSourceInstallationRef refs = 5
     */
    refs: DataSourceInstallationRef[];
}
/**
 * @generated from protobuf message c1.api.integration.datasource.v1.DataSourceCatalogServiceSearchInstallationsResponse
 */
export interface DataSourceCatalogServiceSearchInstallationsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.integration.datasource.v1.DataSourceInstallation list = 1
     */
    list: DataSourceInstallation[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.integration.datasource.v1.DataSourceCatalogServiceConfigurationSchemaRequest
 */
export interface DataSourceCatalogServiceConfigurationSchemaRequest {
    /**
     * @generated from protobuf field: string catalog_id = 1
     */
    catalogId: string;
}
/**
 * @generated from protobuf message c1.api.integration.datasource.v1.DataSourceCatalogServiceConfigurationSchemaResponse
 */
export interface DataSourceCatalogServiceConfigurationSchemaResponse {
    /**
     * @generated from protobuf field: c1.api.integration.connector.v1.ConfigSchema schema = 1
     */
    schema?: ConfigSchema;
}
/**
 * @generated from protobuf message c1.api.integration.datasource.v1.DataSourceCatalogServiceCreateInstallationRequest
 */
export interface DataSourceCatalogServiceCreateInstallationRequest {
    /**
     * @generated from protobuf field: google.protobuf.Any config = 1
     */
    config?: Any;
    /**
     * @generated from protobuf field: string catalog_id = 2
     */
    catalogId: string;
}
/**
 * @generated from protobuf message c1.api.integration.datasource.v1.DataSourceCatalogServiceCreateDelegatedInstallationRequest
 */
export interface DataSourceCatalogServiceCreateDelegatedInstallationRequest {
    /**
     * @generated from protobuf field: google.protobuf.Any config = 1
     */
    config?: Any;
    /**
     * @generated from protobuf field: string catalog_id = 2
     */
    catalogId: string;
    /**
     * @generated from protobuf field: repeated string user_ids = 5
     */
    userIds: string[];
}
/**
 * @generated from protobuf message c1.api.integration.datasource.v1.DataSourceCatalogServiceDeleteInstallationRequest
 */
export interface DataSourceCatalogServiceDeleteInstallationRequest {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.integration.datasource.v1.DataSourceCatalogServiceGetInstallationRequest
 */
export interface DataSourceCatalogServiceGetInstallationRequest {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: c1.api.integration.datasource.v1.DataSourceExpandMask expand_mask = 2
     */
    expandMask?: DataSourceExpandMask;
}
/**
 * @generated from protobuf message c1.api.integration.datasource.v1.DataSourceCatalogServiceGetInstallationResponse
 */
export interface DataSourceCatalogServiceGetInstallationResponse {
    /**
     * @generated from protobuf field: c1.api.integration.datasource.v1.DataSourceInstallationView installation_view = 1
     */
    installationView?: DataSourceInstallationView;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.integration.datasource.v1.DataSourceCatalogServiceUpdateInstallationRequest
 */
export interface DataSourceCatalogServiceUpdateInstallationRequest {
    /**
     * @generated from protobuf field: c1.api.integration.datasource.v1.DataSourceInstallation installation = 1
     */
    installation?: DataSourceInstallation;
    /**
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 2
     */
    updateMask?: FieldMask;
}
// @generated message type with reflection information, may provide speed optimized methods
class DataSourceInstallationView$Type extends MessageType<DataSourceInstallationView> {
    constructor() {
        super("c1.api.integration.datasource.v1.DataSourceInstallationView", [
            { no: 1, name: "installation", kind: "message", T: () => DataSourceInstallation },
            { no: 2, name: "users_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<DataSourceInstallationView>): DataSourceInstallationView {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.usersPath = "";
        if (value !== undefined)
            reflectionMergePartial<DataSourceInstallationView>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DataSourceInstallationView): DataSourceInstallationView {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.integration.datasource.v1.DataSourceInstallation installation */ 1:
                    message.installation = DataSourceInstallation.internalBinaryRead(reader, reader.uint32(), options, message.installation);
                    break;
                case /* string users_path */ 2:
                    message.usersPath = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DataSourceInstallationView, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.integration.datasource.v1.DataSourceInstallation installation = 1; */
        if (message.installation)
            DataSourceInstallation.internalBinaryWrite(message.installation, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string users_path = 2; */
        if (message.usersPath !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.usersPath);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.datasource.v1.DataSourceInstallationView
 */
export const DataSourceInstallationView = new DataSourceInstallationView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DataSourceInstallation$Type extends MessageType<DataSourceInstallation> {
    constructor() {
        super("c1.api.integration.datasource.v1.DataSourceInstallation", [
            { no: 1, name: "catalog", kind: "message", T: () => DataSourceCatalog },
            { no: 2, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 6, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 7, name: "deleted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 8, name: "config", kind: "message", T: () => Any },
            { no: 9, name: "first_validated_at", kind: "message", T: () => Timestamp },
            { no: 10, name: "admin_user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<DataSourceInstallation>): DataSourceInstallation {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.displayName = "";
        message.description = "";
        message.adminUserIds = [];
        if (value !== undefined)
            reflectionMergePartial<DataSourceInstallation>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DataSourceInstallation): DataSourceInstallation {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.integration.datasource.v1.DataSourceCatalog catalog */ 1:
                    message.catalog = DataSourceCatalog.internalBinaryRead(reader, reader.uint32(), options, message.catalog);
                    break;
                case /* string id */ 2:
                    message.id = reader.string();
                    break;
                case /* string display_name */ 3:
                    message.displayName = reader.string();
                    break;
                case /* string description */ 4:
                    message.description = reader.string();
                    break;
                case /* google.protobuf.Timestamp created_at */ 5:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 6:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp deleted_at */ 7:
                    message.deletedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deletedAt);
                    break;
                case /* google.protobuf.Any config */ 8:
                    message.config = Any.internalBinaryRead(reader, reader.uint32(), options, message.config);
                    break;
                case /* google.protobuf.Timestamp first_validated_at */ 9:
                    message.firstValidatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.firstValidatedAt);
                    break;
                case /* repeated string admin_user_ids */ 10:
                    message.adminUserIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DataSourceInstallation, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.integration.datasource.v1.DataSourceCatalog catalog = 1; */
        if (message.catalog)
            DataSourceCatalog.internalBinaryWrite(message.catalog, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string id = 2; */
        if (message.id !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.id);
        /* string display_name = 3; */
        if (message.displayName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.displayName);
        /* string description = 4; */
        if (message.description !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.description);
        /* google.protobuf.Timestamp created_at = 5; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 6; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp deleted_at = 7; */
        if (message.deletedAt)
            Timestamp.internalBinaryWrite(message.deletedAt, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Any config = 8; */
        if (message.config)
            Any.internalBinaryWrite(message.config, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp first_validated_at = 9; */
        if (message.firstValidatedAt)
            Timestamp.internalBinaryWrite(message.firstValidatedAt, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* repeated string admin_user_ids = 10; */
        for (let i = 0; i < message.adminUserIds.length; i++)
            writer.tag(10, WireType.LengthDelimited).string(message.adminUserIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.datasource.v1.DataSourceInstallation
 */
export const DataSourceInstallation = new DataSourceInstallation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DataSourceInstallationRef$Type extends MessageType<DataSourceInstallationRef> {
    constructor() {
        super("c1.api.integration.datasource.v1.DataSourceInstallationRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<DataSourceInstallationRef>): DataSourceInstallationRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<DataSourceInstallationRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DataSourceInstallationRef): DataSourceInstallationRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DataSourceInstallationRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.datasource.v1.DataSourceInstallationRef
 */
export const DataSourceInstallationRef = new DataSourceInstallationRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DataSourceCatalog$Type extends MessageType<DataSourceCatalog> {
    constructor() {
        super("c1.api.integration.datasource.v1.DataSourceCatalog", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "icon_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "logo_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "installed", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "help_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<DataSourceCatalog>): DataSourceCatalog {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.displayName = "";
        message.description = "";
        message.iconUrl = "";
        message.logoUrl = "";
        message.installed = false;
        message.helpUrl = "";
        if (value !== undefined)
            reflectionMergePartial<DataSourceCatalog>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DataSourceCatalog): DataSourceCatalog {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string display_name */ 2:
                    message.displayName = reader.string();
                    break;
                case /* string description */ 3:
                    message.description = reader.string();
                    break;
                case /* string icon_url = 4 [deprecated = true] */ 4:
                    message.iconUrl = reader.string();
                    break;
                case /* string logo_url = 5 [deprecated = true] */ 5:
                    message.logoUrl = reader.string();
                    break;
                case /* bool installed */ 6:
                    message.installed = reader.bool();
                    break;
                case /* string help_url */ 7:
                    message.helpUrl = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DataSourceCatalog, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string display_name = 2; */
        if (message.displayName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.displayName);
        /* string description = 3; */
        if (message.description !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.description);
        /* string icon_url = 4 [deprecated = true]; */
        if (message.iconUrl !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.iconUrl);
        /* string logo_url = 5 [deprecated = true]; */
        if (message.logoUrl !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.logoUrl);
        /* bool installed = 6; */
        if (message.installed !== false)
            writer.tag(6, WireType.Varint).bool(message.installed);
        /* string help_url = 7; */
        if (message.helpUrl !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.helpUrl);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.datasource.v1.DataSourceCatalog
 */
export const DataSourceCatalog = new DataSourceCatalog$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DataSourceCatalogServiceSearchRequest$Type extends MessageType<DataSourceCatalogServiceSearchRequest> {
    constructor() {
        super("c1.api.integration.datasource.v1.DataSourceCatalogServiceSearchRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<DataSourceCatalogServiceSearchRequest>): DataSourceCatalogServiceSearchRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<DataSourceCatalogServiceSearchRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DataSourceCatalogServiceSearchRequest): DataSourceCatalogServiceSearchRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DataSourceCatalogServiceSearchRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.datasource.v1.DataSourceCatalogServiceSearchRequest
 */
export const DataSourceCatalogServiceSearchRequest = new DataSourceCatalogServiceSearchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DataSourceCatalogServiceSearchResponse$Type extends MessageType<DataSourceCatalogServiceSearchResponse> {
    constructor() {
        super("c1.api.integration.datasource.v1.DataSourceCatalogServiceSearchResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => DataSourceCatalog },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<DataSourceCatalogServiceSearchResponse>): DataSourceCatalogServiceSearchResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<DataSourceCatalogServiceSearchResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DataSourceCatalogServiceSearchResponse): DataSourceCatalogServiceSearchResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.integration.datasource.v1.DataSourceCatalog list */ 1:
                    message.list.push(DataSourceCatalog.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DataSourceCatalogServiceSearchResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.integration.datasource.v1.DataSourceCatalog list = 1; */
        for (let i = 0; i < message.list.length; i++)
            DataSourceCatalog.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.datasource.v1.DataSourceCatalogServiceSearchResponse
 */
export const DataSourceCatalogServiceSearchResponse = new DataSourceCatalogServiceSearchResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DataSourceExpandMask$Type extends MessageType<DataSourceExpandMask> {
    constructor() {
        super("c1.api.integration.datasource.v1.DataSourceExpandMask", [
            { no: 1, name: "paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { in: ["*", "admin_user_ids"] } }, ignoreEmpty: true } } } }
        ]);
    }
    create(value?: PartialMessage<DataSourceExpandMask>): DataSourceExpandMask {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.paths = [];
        if (value !== undefined)
            reflectionMergePartial<DataSourceExpandMask>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DataSourceExpandMask): DataSourceExpandMask {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string paths */ 1:
                    message.paths.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DataSourceExpandMask, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string paths = 1; */
        for (let i = 0; i < message.paths.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.paths[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.datasource.v1.DataSourceExpandMask
 */
export const DataSourceExpandMask = new DataSourceExpandMask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DataSourceCatalogServiceGetRequest$Type extends MessageType<DataSourceCatalogServiceGetRequest> {
    constructor() {
        super("c1.api.integration.datasource.v1.DataSourceCatalogServiceGetRequest", [
            { no: 1, name: "catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<DataSourceCatalogServiceGetRequest>): DataSourceCatalogServiceGetRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.catalogId = "";
        if (value !== undefined)
            reflectionMergePartial<DataSourceCatalogServiceGetRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DataSourceCatalogServiceGetRequest): DataSourceCatalogServiceGetRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string catalog_id */ 1:
                    message.catalogId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DataSourceCatalogServiceGetRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string catalog_id = 1; */
        if (message.catalogId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.catalogId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.datasource.v1.DataSourceCatalogServiceGetRequest
 */
export const DataSourceCatalogServiceGetRequest = new DataSourceCatalogServiceGetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DataSourceCatalogServiceSearchInstallationsRequest$Type extends MessageType<DataSourceCatalogServiceSearchInstallationsRequest> {
    constructor() {
        super("c1.api.integration.datasource.v1.DataSourceCatalogServiceSearchInstallationsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "catalog_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 5, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => DataSourceInstallationRef }
        ]);
    }
    create(value?: PartialMessage<DataSourceCatalogServiceSearchInstallationsRequest>): DataSourceCatalogServiceSearchInstallationsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.query = "";
        message.catalogIds = [];
        message.refs = [];
        if (value !== undefined)
            reflectionMergePartial<DataSourceCatalogServiceSearchInstallationsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DataSourceCatalogServiceSearchInstallationsRequest): DataSourceCatalogServiceSearchInstallationsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* string query */ 3:
                    message.query = reader.string();
                    break;
                case /* repeated string catalog_ids */ 4:
                    message.catalogIds.push(reader.string());
                    break;
                case /* repeated c1.api.integration.datasource.v1.DataSourceInstallationRef refs */ 5:
                    message.refs.push(DataSourceInstallationRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DataSourceCatalogServiceSearchInstallationsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* string query = 3; */
        if (message.query !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.query);
        /* repeated string catalog_ids = 4; */
        for (let i = 0; i < message.catalogIds.length; i++)
            writer.tag(4, WireType.LengthDelimited).string(message.catalogIds[i]);
        /* repeated c1.api.integration.datasource.v1.DataSourceInstallationRef refs = 5; */
        for (let i = 0; i < message.refs.length; i++)
            DataSourceInstallationRef.internalBinaryWrite(message.refs[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.datasource.v1.DataSourceCatalogServiceSearchInstallationsRequest
 */
export const DataSourceCatalogServiceSearchInstallationsRequest = new DataSourceCatalogServiceSearchInstallationsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DataSourceCatalogServiceSearchInstallationsResponse$Type extends MessageType<DataSourceCatalogServiceSearchInstallationsResponse> {
    constructor() {
        super("c1.api.integration.datasource.v1.DataSourceCatalogServiceSearchInstallationsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => DataSourceInstallation },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<DataSourceCatalogServiceSearchInstallationsResponse>): DataSourceCatalogServiceSearchInstallationsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<DataSourceCatalogServiceSearchInstallationsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DataSourceCatalogServiceSearchInstallationsResponse): DataSourceCatalogServiceSearchInstallationsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.integration.datasource.v1.DataSourceInstallation list */ 1:
                    message.list.push(DataSourceInstallation.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DataSourceCatalogServiceSearchInstallationsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.integration.datasource.v1.DataSourceInstallation list = 1; */
        for (let i = 0; i < message.list.length; i++)
            DataSourceInstallation.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.datasource.v1.DataSourceCatalogServiceSearchInstallationsResponse
 */
export const DataSourceCatalogServiceSearchInstallationsResponse = new DataSourceCatalogServiceSearchInstallationsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DataSourceCatalogServiceConfigurationSchemaRequest$Type extends MessageType<DataSourceCatalogServiceConfigurationSchemaRequest> {
    constructor() {
        super("c1.api.integration.datasource.v1.DataSourceCatalogServiceConfigurationSchemaRequest", [
            { no: 1, name: "catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<DataSourceCatalogServiceConfigurationSchemaRequest>): DataSourceCatalogServiceConfigurationSchemaRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.catalogId = "";
        if (value !== undefined)
            reflectionMergePartial<DataSourceCatalogServiceConfigurationSchemaRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DataSourceCatalogServiceConfigurationSchemaRequest): DataSourceCatalogServiceConfigurationSchemaRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string catalog_id */ 1:
                    message.catalogId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DataSourceCatalogServiceConfigurationSchemaRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string catalog_id = 1; */
        if (message.catalogId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.catalogId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.datasource.v1.DataSourceCatalogServiceConfigurationSchemaRequest
 */
export const DataSourceCatalogServiceConfigurationSchemaRequest = new DataSourceCatalogServiceConfigurationSchemaRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DataSourceCatalogServiceConfigurationSchemaResponse$Type extends MessageType<DataSourceCatalogServiceConfigurationSchemaResponse> {
    constructor() {
        super("c1.api.integration.datasource.v1.DataSourceCatalogServiceConfigurationSchemaResponse", [
            { no: 1, name: "schema", kind: "message", T: () => ConfigSchema }
        ]);
    }
    create(value?: PartialMessage<DataSourceCatalogServiceConfigurationSchemaResponse>): DataSourceCatalogServiceConfigurationSchemaResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<DataSourceCatalogServiceConfigurationSchemaResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DataSourceCatalogServiceConfigurationSchemaResponse): DataSourceCatalogServiceConfigurationSchemaResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.integration.connector.v1.ConfigSchema schema */ 1:
                    message.schema = ConfigSchema.internalBinaryRead(reader, reader.uint32(), options, message.schema);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DataSourceCatalogServiceConfigurationSchemaResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.integration.connector.v1.ConfigSchema schema = 1; */
        if (message.schema)
            ConfigSchema.internalBinaryWrite(message.schema, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.datasource.v1.DataSourceCatalogServiceConfigurationSchemaResponse
 */
export const DataSourceCatalogServiceConfigurationSchemaResponse = new DataSourceCatalogServiceConfigurationSchemaResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DataSourceCatalogServiceCreateInstallationRequest$Type extends MessageType<DataSourceCatalogServiceCreateInstallationRequest> {
    constructor() {
        super("c1.api.integration.datasource.v1.DataSourceCatalogServiceCreateInstallationRequest", [
            { no: 1, name: "config", kind: "message", T: () => Any },
            { no: 2, name: "catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<DataSourceCatalogServiceCreateInstallationRequest>): DataSourceCatalogServiceCreateInstallationRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.catalogId = "";
        if (value !== undefined)
            reflectionMergePartial<DataSourceCatalogServiceCreateInstallationRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DataSourceCatalogServiceCreateInstallationRequest): DataSourceCatalogServiceCreateInstallationRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Any config */ 1:
                    message.config = Any.internalBinaryRead(reader, reader.uint32(), options, message.config);
                    break;
                case /* string catalog_id */ 2:
                    message.catalogId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DataSourceCatalogServiceCreateInstallationRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Any config = 1; */
        if (message.config)
            Any.internalBinaryWrite(message.config, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string catalog_id = 2; */
        if (message.catalogId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.catalogId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.datasource.v1.DataSourceCatalogServiceCreateInstallationRequest
 */
export const DataSourceCatalogServiceCreateInstallationRequest = new DataSourceCatalogServiceCreateInstallationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DataSourceCatalogServiceCreateDelegatedInstallationRequest$Type extends MessageType<DataSourceCatalogServiceCreateDelegatedInstallationRequest> {
    constructor() {
        super("c1.api.integration.datasource.v1.DataSourceCatalogServiceCreateDelegatedInstallationRequest", [
            { no: 1, name: "config", kind: "message", T: () => Any },
            { no: 2, name: "catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 5, name: "user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
    create(value?: PartialMessage<DataSourceCatalogServiceCreateDelegatedInstallationRequest>): DataSourceCatalogServiceCreateDelegatedInstallationRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.catalogId = "";
        message.userIds = [];
        if (value !== undefined)
            reflectionMergePartial<DataSourceCatalogServiceCreateDelegatedInstallationRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DataSourceCatalogServiceCreateDelegatedInstallationRequest): DataSourceCatalogServiceCreateDelegatedInstallationRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Any config */ 1:
                    message.config = Any.internalBinaryRead(reader, reader.uint32(), options, message.config);
                    break;
                case /* string catalog_id */ 2:
                    message.catalogId = reader.string();
                    break;
                case /* repeated string user_ids */ 5:
                    message.userIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DataSourceCatalogServiceCreateDelegatedInstallationRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Any config = 1; */
        if (message.config)
            Any.internalBinaryWrite(message.config, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string catalog_id = 2; */
        if (message.catalogId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.catalogId);
        /* repeated string user_ids = 5; */
        for (let i = 0; i < message.userIds.length; i++)
            writer.tag(5, WireType.LengthDelimited).string(message.userIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.datasource.v1.DataSourceCatalogServiceCreateDelegatedInstallationRequest
 */
export const DataSourceCatalogServiceCreateDelegatedInstallationRequest = new DataSourceCatalogServiceCreateDelegatedInstallationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DataSourceCatalogServiceDeleteInstallationRequest$Type extends MessageType<DataSourceCatalogServiceDeleteInstallationRequest> {
    constructor() {
        super("c1.api.integration.datasource.v1.DataSourceCatalogServiceDeleteInstallationRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<DataSourceCatalogServiceDeleteInstallationRequest>): DataSourceCatalogServiceDeleteInstallationRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<DataSourceCatalogServiceDeleteInstallationRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DataSourceCatalogServiceDeleteInstallationRequest): DataSourceCatalogServiceDeleteInstallationRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DataSourceCatalogServiceDeleteInstallationRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.datasource.v1.DataSourceCatalogServiceDeleteInstallationRequest
 */
export const DataSourceCatalogServiceDeleteInstallationRequest = new DataSourceCatalogServiceDeleteInstallationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DataSourceCatalogServiceGetInstallationRequest$Type extends MessageType<DataSourceCatalogServiceGetInstallationRequest> {
    constructor() {
        super("c1.api.integration.datasource.v1.DataSourceCatalogServiceGetInstallationRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 2, name: "expand_mask", kind: "message", T: () => DataSourceExpandMask }
        ]);
    }
    create(value?: PartialMessage<DataSourceCatalogServiceGetInstallationRequest>): DataSourceCatalogServiceGetInstallationRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<DataSourceCatalogServiceGetInstallationRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DataSourceCatalogServiceGetInstallationRequest): DataSourceCatalogServiceGetInstallationRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* c1.api.integration.datasource.v1.DataSourceExpandMask expand_mask */ 2:
                    message.expandMask = DataSourceExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DataSourceCatalogServiceGetInstallationRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* c1.api.integration.datasource.v1.DataSourceExpandMask expand_mask = 2; */
        if (message.expandMask)
            DataSourceExpandMask.internalBinaryWrite(message.expandMask, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.datasource.v1.DataSourceCatalogServiceGetInstallationRequest
 */
export const DataSourceCatalogServiceGetInstallationRequest = new DataSourceCatalogServiceGetInstallationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DataSourceCatalogServiceGetInstallationResponse$Type extends MessageType<DataSourceCatalogServiceGetInstallationResponse> {
    constructor() {
        super("c1.api.integration.datasource.v1.DataSourceCatalogServiceGetInstallationResponse", [
            { no: 1, name: "installation_view", kind: "message", T: () => DataSourceInstallationView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<DataSourceCatalogServiceGetInstallationResponse>): DataSourceCatalogServiceGetInstallationResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<DataSourceCatalogServiceGetInstallationResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DataSourceCatalogServiceGetInstallationResponse): DataSourceCatalogServiceGetInstallationResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.integration.datasource.v1.DataSourceInstallationView installation_view */ 1:
                    message.installationView = DataSourceInstallationView.internalBinaryRead(reader, reader.uint32(), options, message.installationView);
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DataSourceCatalogServiceGetInstallationResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.integration.datasource.v1.DataSourceInstallationView installation_view = 1; */
        if (message.installationView)
            DataSourceInstallationView.internalBinaryWrite(message.installationView, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.datasource.v1.DataSourceCatalogServiceGetInstallationResponse
 */
export const DataSourceCatalogServiceGetInstallationResponse = new DataSourceCatalogServiceGetInstallationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DataSourceCatalogServiceUpdateInstallationRequest$Type extends MessageType<DataSourceCatalogServiceUpdateInstallationRequest> {
    constructor() {
        super("c1.api.integration.datasource.v1.DataSourceCatalogServiceUpdateInstallationRequest", [
            { no: 1, name: "installation", kind: "message", T: () => DataSourceInstallation, options: { "validate.rules": { message: { skip: true } } } },
            { no: 2, name: "update_mask", kind: "message", T: () => FieldMask }
        ]);
    }
    create(value?: PartialMessage<DataSourceCatalogServiceUpdateInstallationRequest>): DataSourceCatalogServiceUpdateInstallationRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<DataSourceCatalogServiceUpdateInstallationRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DataSourceCatalogServiceUpdateInstallationRequest): DataSourceCatalogServiceUpdateInstallationRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.integration.datasource.v1.DataSourceInstallation installation */ 1:
                    message.installation = DataSourceInstallation.internalBinaryRead(reader, reader.uint32(), options, message.installation);
                    break;
                case /* google.protobuf.FieldMask update_mask */ 2:
                    message.updateMask = FieldMask.internalBinaryRead(reader, reader.uint32(), options, message.updateMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DataSourceCatalogServiceUpdateInstallationRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.integration.datasource.v1.DataSourceInstallation installation = 1; */
        if (message.installation)
            DataSourceInstallation.internalBinaryWrite(message.installation, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.FieldMask update_mask = 2; */
        if (message.updateMask)
            FieldMask.internalBinaryWrite(message.updateMask, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.datasource.v1.DataSourceCatalogServiceUpdateInstallationRequest
 */
export const DataSourceCatalogServiceUpdateInstallationRequest = new DataSourceCatalogServiceUpdateInstallationRequest$Type();
/**
 * @generated ServiceType for protobuf service c1.api.integration.datasource.v1.DataSourceCatalogService
 */
export const DataSourceCatalogService = new ServiceType("c1.api.integration.datasource.v1.DataSourceCatalogService", [
    { name: "ConfigurationSchema", options: { "authz.method": { role: "VIEWER" } }, I: DataSourceCatalogServiceConfigurationSchemaRequest, O: DataSourceCatalogServiceConfigurationSchemaResponse },
    { name: "Get", options: { "authz.method": { role: "VIEWER" } }, I: DataSourceCatalogServiceGetRequest, O: DataSourceCatalog },
    { name: "Search", options: { "authz.method": { role: "VIEWER" } }, I: DataSourceCatalogServiceSearchRequest, O: DataSourceCatalogServiceSearchResponse },
    { name: "SearchInstallations", options: { "authz.method": { role: "VIEWER" } }, I: DataSourceCatalogServiceSearchInstallationsRequest, O: DataSourceCatalogServiceSearchInstallationsResponse },
    { name: "CreateInstallation", options: { "authz.method": { role: "EDITOR" } }, I: DataSourceCatalogServiceCreateInstallationRequest, O: DataSourceInstallation },
    { name: "CreateDelegatedInstallation", options: { "authz.method": { role: "EDITOR" } }, I: DataSourceCatalogServiceCreateDelegatedInstallationRequest, O: DataSourceInstallation },
    { name: "DeleteInstallation", options: { "authz.method": { role: "EDITOR" } }, I: DataSourceCatalogServiceDeleteInstallationRequest, O: Empty },
    { name: "GetInstallation", options: { "authz.method": { role: "VIEWER" } }, I: DataSourceCatalogServiceGetInstallationRequest, O: DataSourceCatalogServiceGetInstallationResponse },
    { name: "UpdateInstallation", options: { "authz.method": { role: "EDITOR" } }, I: DataSourceCatalogServiceUpdateInstallationRequest, O: DataSourceInstallation }
]);
